export default {
	changePassword: {
		'Change Password': '修改密碼',
		'Set Password': '設定密碼',
	},
	profile: {
		绑定手机号: '綁定手機號',
		绑定邮箱: '綁定郵箱',
		裁剪人脸: '裁剪人臉照片',
		裁剪要求: '裁剪要求',
		查看认证信息: '查看',
		查看原因: '查看原因',
		城市: '城市',
		待审核: '待審核',
		当前: '當前',
		当前尺寸: '當前尺寸',
		地址: '地址',
		点击认证: '點擊認證',
		二要素认证: '二要素認證',
		二要素说明: '校驗姓名與身份證號是否一致',
		放大: '放大',
		分辨率太低: '解析度太低，至少需要 480 × 640 像素',
		更换手机号: '更換手機號',
		更换邮箱: '更換郵箱',
		公司名称: '公司名稱',
		'国家/地区': '國家/地區',
		基本信息: '基本資料',
		仅支持jpg_png_webp: '僅支援 jpg / png / webp 格式',
		仅支持PNG_JPG_JPEG: '僅支援 PNG / JPG / JPEG 格式',
		拒绝原因: '拒絕原因',
		开始扫脸认证: '開始掃臉認證',
		请上传人脸图片: '請上傳人臉圖片',
		请填写18位身份证号: '請填寫身份證號',
		请填写本人实名手机号: '請填寫本人實名手機號',
		请填写有效的11位手机号: '請填寫有效的11位手機號',
		请填写有效的18位身份证号: '請填寫有效的18位身份證號',
		请填写有效的手机号: '請填寫有效的手機號',
		请填写真实姓名: '請填寫真實姓名',
		去认证: '去認證',
		人脸说明: '請上傳 PNG / JPG / JPEG 格式的本人正面照，光線充足、無遮擋；裁剪後將以 3:4 直版輸出，自動壓縮到 1MB 以內',
		人脸图片: '人臉圖片',
		认证成功: '認證成功',
		认证类型: '認證類型',
		认证失败: '認證失敗',
		认证信息: '認證信息',
		若窗口未自动打开请点击: '若視窗未自動開啟請點擊',
		三要素认证: '三要素認證',
		三要素说明: '校驗姓名、身份證號、手機號是否一致',
		扫脸初始化失败: '掃臉初始化失敗',
		扫脸认证: '掃臉認證',
		扫脸说明: '點擊下方按鈕，將在新視窗開啟阿里雲掃臉頁面，完成後回到此頁點擊「我已完成掃臉」',
		扫脸跳转说明: '已在新視窗開啟掃臉頁面，完成後回到此處點擊「我已完成掃臉」',
		身份证号: '身份證號',
		审核不通过: '審核不通過',
		审核中提示: '資料審核中，請耐心等待審核',
		实名认证: '實名認證',
		实名认证信息: '實名認證信息',
		实时预览: '即時預覽',
		手动打开扫脸页面: '手動開啟掃臉頁面',
		手机号: '手機號',
		缩小: '縮小',
		提升认证等级: '點擊提升',
		图片不能超过4MB: '圖片不能超過 4MB',
		图片仍超过1MB请重新裁剪: '裁剪後圖片仍超過 1MB，請重新裁剪縮小範圍',
		未绑定: '未綁定',
		未认证: '未認證',
		未填写: '未填寫',
		我已完成扫脸: '我已完成掃臉',
		无拒绝原因: '管理員未填寫拒絕原因',
		姓名: '姓名',
		修改基本信息: '修改基本信息',
		修改信息: '修改資料',
		要求: '要求',
		要求_大小: '裁剪後體積自動壓到 1MB 以內',
		要求_分辨率: '解析度 480×640 ~ 1080×1920',
		要求_格式: '格式：PNG / JPG / JPEG',
		要求_竖版: '高 > 寬（3:4 直版自動鎖定）',
		已绑定: '已綁定',
		已认证: '已認證',
		邮箱: '郵箱',
		邮箱更换成功提示: '郵箱更換成功，點擊「確定」重新整理頁面',
		邮箱未绑定: '郵箱未綁定',
		邮箱已绑定: '郵箱已綁定',
		邮政编码: '郵政編碼',
		右转: '右轉',
		语言: '語言',
		预估大小: '預估大小',
		原图不能超过10MB: '原圖不能超過 10MB',
		重新认证: '重新認證',
		重新填写: '重新填寫',
		重置: '重置',
		左转: '左轉',
	},
	城市: '城市',
	当前密码: '當前密碼',
	地区: '地區',
	地址: '地址',
	地址信息: '地址信息',
	登录信息: '登錄信息',
	电话号码: '電話號碼',
	电话前缀: '電話前綴',
	电话前缀和手机号不能为空: '電話前綴和手機號不能為空',
	发送: '發送',
	发送验证码: '發送驗證碼',
	个人签名: '個性籤名',
	个人资料: '個人資料',
	更换: '更換',
	更换邮箱: '更換郵箱',
	公司名称: '公司名稱',
	关闭: '關閉',
	国家: '國家',
	'国家/地区': '國家/地區',
	获取验证码: '獲取驗證碼',
	基本信息: '基本信息',
	旧密码: '舊密碼',
	联系方式: '聯繫方式',
	密码: '密碼',
	秒: '秒',
	名字: '名字',
	取消: '取消',
	'确定提交吗？': '確定提交嗎？',
	确认密码: '確認密碼',
	生日: '生日',
	手机号: '手機號',
	提交: '提交',
	退出登录: '退出登錄',
	完成: '完成',
	未验证: '未驗證',
	下一步: '下一步',
	新密码: '新密碼',
	新密码不能与旧密码相同: '新密碼不能與舊密碼相同',
	确认密码与密码不一致: '確認密碼與密碼不一致',
	新邮箱地址: '新郵箱地址',
	新邮箱认证: '新郵箱認證',
	新邮箱验证码: '新郵箱驗證碼',
	信息认证: '信息認證',
	姓氏: '姓氏',
	性别: '性別',
	修改或完善资料: '修改或完善資料',
	验证: '驗證',
	验证码: '驗證碼',
	已验证: '已驗證',
	邮箱地址: '郵箱地址',
	'邮箱更换成功，请退出系统重新登录': '郵箱更換成功，請退出系統重新登錄',
	邮箱认证: '郵箱認證',
	邮政编码: '郵政編碼',
	语言: '語言',
	重复密码: '重複密碼',
	重复新密码: '重複新密碼',
	最后登录时间: '最後登錄時間',
	最后登录IP: '最後登錄IP',
}
